import { Link } from "react-router-dom";
import { usePoll, fmt } from "../lib/api";
import { PageHeader, Panel } from "../components/shared";
import Schedule90Button from "../components/Schedule90Button";
import NinetyDayGrid from "../components/NinetyDayGrid";

const Legend = () => (
  <div className="flex flex-wrap gap-4 font-mono text-[10px] text-[#9CA3AF] mb-4" data-testid="h90-legend">
    <span><span className="inline-block w-2 h-2 rounded-sm bg-[#A78BFA] mr-1" />T2 PREP</span>
    <span><span className="inline-block w-2 h-2 rounded-sm bg-[#F59E0B] mr-1" />T3 ASSEMBLY</span>
    <span><span className="inline-block w-2 h-2 border-l-2 border-[#10B981] mr-1" />FOR A PRODUCTION PLAN</span>
    <span><span className="inline-block w-2 h-2 rounded-sm ring-1 ring-[#EF4444] mr-1" />LATE</span>
    <span>W1 = LIVE WEEKLY SCHEDULE</span>
  </div>
);

export default function Schedule90() {
  const { data, refresh } = usePoll("/schedule/horizon", 10000);
  return (
    <div data-testid="schedule-90-page">
      <PageHeader kicker="// CAPACITY-CONSTRAINED · 90-DAY HORIZON" title="90-Day Schedule">
        <Schedule90Button onDone={refresh} />
      </PageHeader>
      {!data ? <Panel className="p-8 text-[#9CA3AF]">Loading…</Panel> : (<>
        <div className="flex flex-wrap items-center gap-4 mb-3 font-mono text-xs text-[#9CA3AF]">
          {data.generated ? <span data-testid="h90-generated">GENERATED {new Date(data.generated_at).toLocaleString()}</span> : <span data-testid="h90-not-generated" className="text-[#F59E0B]">Days 8–90 not planned yet. Tap Schedule Next 90 Days.</span>}
          {data.generated && !data.synced && <span data-testid="h90-stale" className="text-[#F59E0B]">Week 1 was re-planned since the last 90-day run; run it again to re-sync days 8–90.</span>}
          <Link to="/schedule" className="text-[#38BDF8] underline" data-testid="h90-weekly-link">Edit week 1 in Weekly Schedule</Link>
        </div>
        <Legend />
        {data.days.length ? <NinetyDayGrid data={data} /> : <Panel className="p-8 text-[#9CA3AF]" data-testid="h90-empty">No schedule yet.</Panel>}
        {data.backlog.length > 0 && (
          <Panel className="p-5 mt-6 border-[#F59E0B]/50" data-testid="h90-backlog">
            <div className="font-mono text-xs tracking-[0.2em] text-[#F59E0B] mb-3">OVER 90-DAY CAPACITY · NOT SCHEDULED</div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2">
              {data.backlog.map((b, i) => <div key={i} className="p-3 rounded-md border border-[#1E293B] text-sm"><div className="font-semibold">{b.name}</div><div className="font-mono text-xs text-[#9CA3AF]">{fmt(b.qty)} units · need by {b.need_by}{b.reason === "plan" ? " · PLAN" : ""}</div></div>)}
            </div>
          </Panel>
        )}
      </>)}
    </div>
  );
}
